import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=175663ea&scoped=true"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=175663ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175663ea",
  null
  
)

export default component.exports